import React from 'react'
import ReactDOM from 'react-dom'
import Post from './Post'

/**
 * TimelinePostTooltip - portálban renderelt post tooltip
 *
 * Props:
 * - hoveredPost: { id, post, x, y } | null
 * - onClose: () => void
 * - hideTooltipTimeoutRef: React.MutableRefObject<number | null>
 * - reach: number (opcionális, a CFR és engagement rate számításához)
 */
export default function TimelinePostTooltip({ hoveredPost, onClose, hideTooltipTimeoutRef, reach }) {
  if (!hoveredPost) return null

  // Döntsük el, hogy a pont fölé vagy alá fér el jobban a tooltip
  const viewportHeight = typeof window !== 'undefined' ? window.innerHeight || 0 : 0
  const estimatedTooltipHeight = 220 // kb. 200-220px magas lehet a tooltip
  const prefersAbove = hoveredPost.y > estimatedTooltipHeight + 16 && hoveredPost.y > viewportHeight / 2

  const top = prefersAbove ? hoveredPost.y - 8 : hoveredPost.y + 8
  const transform = prefersAbove ? 'translate(-50%, -100%)' : 'translate(-50%, 0)'

  return ReactDOM.createPortal(
    <div
      className="fixed z-[9999]"
      style={{
        top,
        left: hoveredPost.x,
        transform,
      }}
      onMouseEnter={() => {
        if (hideTooltipTimeoutRef?.current) {
          clearTimeout(hideTooltipTimeoutRef.current)
          hideTooltipTimeoutRef.current = null
        }
      }}
      onMouseLeave={onClose}
    >
      <Post post={hoveredPost.post} reach={reach} asLink={false} />
    </div>,
    document.body
  )
}

